import reports from "./reports";
import settings from "./settings";
import users from "./users";
import auth from "./auth";

export default {
  reports,
  settings,
  users,
  auth,
  type: 'LOCAL'
}